import type { BookRecord, RecordStatus } from '../types';

/** Sort returned records with the most recently returned at the top. */
export function sortBookRecords(
  records: BookRecord[],
  statusFilter: RecordStatus | ''
): BookRecord[] {
  if (statusFilter !== 'returned') {
    return records;
  }

  return [...records].sort((a, b) => {
    const dateA = a.return_date ? new Date(a.return_date).getTime() : 0;
    const dateB = b.return_date ? new Date(b.return_date).getTime() : 0;
    return dateB - dateA;
  });
}
